import { Typography, Stack, List, ListItem } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SummaryListItem } from "../types/SummaryListItem.ts";

const ListNoPadding = styled(List)({
  padding: 0,
  margin: 0,
});

const ListItemWithBorder = styled(ListItem)<{ borderColor: string }>(
  ({ theme, borderColor }) => ({
    borderLeftWidth: "1px",
    borderLeftStyle: "solid",
    borderColor: borderColor,
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  }),
);

type SummaryListProps = {
  textContent: SummaryListItem[];
};

export const SummaryList = ({ textContent }: SummaryListProps) => (
  <Stack direction={"column"} spacing={2}>
    {textContent.map(({ title, borderColor, listItems }) => (
      <Stack key={title} direction={"column"} spacing={1}>
        {title && listItems.length > 0 && (
          <Typography variant={"body2"}>{title}</Typography>
        )}
        <ListNoPadding>
          {listItems.map((listItem) => (
            <ListItemWithBorder key={listItem} borderColor={borderColor}>
              <Typography variant={"body2"} color={"text.secondary"}>
                {listItem}
              </Typography>
            </ListItemWithBorder>
          ))}
        </ListNoPadding>
      </Stack>
    ))}
  </Stack>
);
